import { Tooltip, UIText2 } from '@cian/ui-kit';
import { Faq16 } from '@cian/ui-kit/prev';
import * as React from 'react';
import * as styles from './AuctionPointsHint.css';

interface IProps {
  typeName: string;
}

export const AuctionPointsHint = (props: IProps) => {
  const { typeName } = props;

  return (
    <Tooltip
      theme="black"
      placement="right-start"
      title={
        <div className={styles['content']}>
          <UIText2 color="white_100">
            Используйте баллы на&nbsp;продвижение в&nbsp;любых регионах и&nbsp;категориях в&nbsp;течение 30&nbsp;дней
            со&nbsp;дня старта {typeName}.
          </UIText2>
          <UIText2 color="white_100">1&nbsp;балл = 1&nbsp;рубль.</UIText2>
        </div>
      }
    >
      <div className={styles['icon']}>
        <Faq16 color="primary_100" cursor="pointer" />
      </div>
    </Tooltip>
  );
};
